import React from 'react';
import './Breadcrumbs.css';

function Breadcrumbs({ breadcrumbs, onBreadcrumbClick }) {
  return (
    <nav className="breadcrumbs">
      <div className="breadcrumbs-container">
        {breadcrumbs.map((crumb, index) => (
          <React.Fragment key={crumb.id}>
            <button
              className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'active' : ''}`}
              onClick={() => onBreadcrumbClick(index)}
              disabled={index === breadcrumbs.length - 1}
            >
              {crumb.name}
            </button>
            {index < breadcrumbs.length - 1 && (
              <span className="breadcrumb-separator">›</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
}

export default Breadcrumbs;
